import React from 'react'
import classNames from 'classnames'
import { type ArrayFieldTemplateItemType } from '@rjsf/utils'
import { Button } from '../../../Button/Button'

export interface RemoveIconButtonProps {
  onClick?: React.MouseEventHandler<HTMLButtonElement>
  disabled?: boolean
  label?: string
  className?: string
  style?: React.CSSProperties
}

export const RemoveIconButton: React.FC<RemoveIconButtonProps> = ({ onClick, disabled, label = 'Remove item', className, style }) => (
  <Button
    type='button'
    variant='borderless'
    aria-label={label}
    className={classNames('flex-shrink-0 p-2 bg-transparent', className)}
    style={style}
    disabled={disabled}
    onClick={onClick}
  >
    <i className='bi bi-trash' aria-hidden='true' />
  </Button>
)

export const ItemRemoveButton: React.FC<{ item: ArrayFieldTemplateItemType; noun: string; className?: string }> = ({ item, noun, className }) =>
  item.hasRemove && !item.readonly ? (
    <RemoveIconButton
      label={`Remove ${noun} ${item.index + 1}`}
      className={className}
      disabled={Boolean(item.disabled)}
      onClick={item.onDropIndexClick(item.index)}
    />
  ) : null
